import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'AuthorBio',
})(({ brandColors, spacing, fontWeights, typography: { pxToRem } }) => ({
  authorBio: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing(1),
    maxWidth: '100%',
  },
  card: {
    padding: spacing(1, 2),
    borderRadius: pxToRem(8),
    backgroundColor: brandColors.tintsOffWhite50,
  },
  image: {
    width: pxToRem(64),
    height: pxToRem(64),
    borderRadius: '50%',
    objectFit: 'cover',
    flexShrink: 0,
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(-1),
  },
  name: {
    color: brandColors.textPrimary,
    fontWeight: fontWeights.semibold,
  },
  nameLink: {
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  bio: {
    color: brandColors.tintsNeutral20,
  },
}));

export default useStyles;
